export * from "ce/pages/Editor/IDE/EditorPane/JS/utils";

import {
  getJSEntityItemUrl as CE_getJSEntityItemUrl,
  getJSUrl as CE_getJSUrl,
} from "ce/pages/Editor/IDE/EditorPane/JS/utils";
import type { EntityItem } from "ee/entities/IDE/constants";
import { moduleInstanceEditorURL } from "ee/RouteBuilder";
import { MODULE_TYPE } from "ee/constants/ModuleConstants";
import { FocusEntity, type FocusEntityInfo } from "navigation/FocusEntity";

export const getJSEntityItemUrl = (
  item: EntityItem,
  basePageId: string,
): string => {
  if (item.isModuleInstance) {
    return moduleInstanceEditorURL({
      basePageId,
      moduleType: MODULE_TYPE.JS,
      moduleInstanceId: item.key,
    });
  }
  return CE_getJSEntityItemUrl(item, basePageId);
};

export const getJSUrl = (
  item: FocusEntityInfo,
  add: boolean = true,
): string => {
  if (item.entity === FocusEntity.JS_MODULE_INSTANCE) {
    return moduleInstanceEditorURL({
      moduleInstanceId: item.id,
      add,
      moduleType: MODULE_TYPE.JS,
    });
  }
  return CE_getJSUrl(item, add);
};
